// Centralized, production-safe logging helpers.
//
// - logWarn: the single intentional warning channel for genuine, non-fatal
//   failures (network/storage). Kept in production so real issues stay
//   diagnosable. Callers must never pass tokens, passwords, or personal data.
// - ignore: an explicit no-op for intentional swallows where a safe fallback
//   value has already been applied (optional storage / JSON parse reads). It
//   documents that the failure is deliberate rather than a forgotten catch.

export function logWarn(context, err) {
  console.warn(`Chronicles: ${context}`, err?.message || err);
}

export function ignore(_err) {
  // Intentional no-op: optional operation failed; safe fallback already applied.
  return undefined;
}
